/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".modalWidthBig[_ngcontent-%COMP%]{width:50%!important}.table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{padding:5px!important;font-size:13px!important}.pad0[_ngcontent-%COMP%]{padding:0}ol[_ngcontent-%COMP%]{padding-left:25px}li[_ngcontent-%COMP%]{font-size:13px;margin-bottom:5px}.impNotesMdl[_ngcontent-%COMP%]   .modal-dialog[_ngcontent-%COMP%]{max-width:600px!important;margin:0 auto}@media only screen and (max-width:1000px){.impNotesMdl[_ngcontent-%COMP%]   .modal-dialog[_ngcontent-%COMP%]{width:95%!important;max-width:800px!important;margin:30px auto}}"];
export { styles as styles };

